/**
 * Sidebar open/close requests as a window event. Kept free of React and view
 * imports so services (e.g. search) can ask a sidebar to close.
 */
export type WorkspacePaneSidebarTarget =
  | 'apps'
  | 'app-base'
  | 'hub'
  | 'mail'
  | 'planner'
  | 'workflows'
  | 'workspace';

export const WORKSPACE_PANE_SIDEBAR_EVENT = 'streamlain:workspace-pane-sidebar';

export type WorkspacePaneSidebarAction = 'open' | 'close' | 'toggle';

/** Next open state of a sidebar for a request; shared by every listener. */
export function nextWorkspacePaneSidebarOpen(
  action: WorkspacePaneSidebarAction | undefined,
  currentOpen: boolean
): boolean {
  if (action === 'open') return true;
  if (action === 'close') return false;
  return !currentOpen;
}

export function requestWorkspacePaneSidebar(
  target: WorkspacePaneSidebarTarget,
  action: WorkspacePaneSidebarAction = 'toggle'
): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(WORKSPACE_PANE_SIDEBAR_EVENT, {
      detail: { action, target },
    })
  );
}
